import React, { memo, useState } from 'react'
import Modal from './Modal'
import {
  newCategory,
  categoriesColors,
  CategoriesTypesColors,
  categoriesActiveColor,
} from '../../functions/stateList'
import CarModalInput from '../inputs/CarModalInput'
import ModalSubmitFormButton from '../buttons/ModalSubmitFormButton'
import { addCategoriesSubmitHandler } from '../../functions/AddCategoriesModalSubmit'

function AddCategoriesModal({ customerTypes, setCustomerTypes, setShowModal }) {
  const [inputs, setInputs] = useState({ ...newCategory })

  const [error, setError] = useState({ ...newCategory })

  const [isSubmit, setIsSubmit] = useState(false)

  const setColor = (color) => {
    setInputs({
      ...inputs,
      color,
    })
    setError({
      ...error,
      color: '',
    })
  }

  const inputHandler = (e) => {
    let name = e.target.name
    let value = e.target.value

    setInputs({
      ...inputs,
      [name]: value,
    })

    setError({
      ...error,
      [name]: '',
    })
  }

  const formHandler = async (e) => {
    e.preventDefault()
    setIsSubmit(true)
    await addCategoriesSubmitHandler(
      inputs,
      error,
      setError,
      customerTypes,
      setCustomerTypes,
      setShowModal,
      setIsSubmit
    )
  }

  return (
    <Modal>
      <form onSubmit={formHandler}>
        {/*header*/}
        <div className="p-3 md:p-5">
          <h3 className="text-xl md:text-3xl font-semibold text-center dark:text-slate-200">
            افزودن دسته بندی
          </h3>
        </div>

        {/*body*/}
        <div className="relative p-6 flex flex-col">
          <CarModalInput
            title={'نام دسته بندی'}
            type={'text'}
            isSubmit={isSubmit}
            name={'value'}
            value={inputs?.value}
            inputHandler={inputHandler}
            error={error}
          />

          <div className="flex justify-between grid grid-cols-4 gap-4">
            {CategoriesTypesColors.map((info) => (
              <div
                key={info.id}
                onClick={() => setColor(info?.color)}
                className={inputs?.color === info?.color ? categoriesActiveColor : categoriesColors}
                style={{ backgroundColor: `${info?.color}` }}
              />
            ))}
          </div>
        </div>

        {/*footer*/}
        <ModalSubmitFormButton setShowModal={setShowModal} isSubmit={isSubmit} />
      </form>
    </Modal>
  )
}

export default memo(AddCategoriesModal)
